import { render, staticRenderFns } from "./leave-request-item.vue?vue&type=template&id=24d95656&scoped=true&"
import script from "./leave-request-item.vue?vue&type=script&lang=js&"
export * from "./leave-request-item.vue?vue&type=script&lang=js&"
import style0 from "./leave-request-item.vue?vue&type=style&index=0&id=24d95656&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d95656",
  null
  
)

export default component.exports